export default __webpack_public_path__ + "static/media/roles.e2b2d66f.svg";